import {
  AmountDimension,
  BooleanDimension,
  ExclusionDimension,
  FinancialRateDimension,
  FinancialRateWithUnsetDimension,
} from '@orus.eu/dimensions'

export * from './rcph-activity-dimension.ts'
export * from './rcph-cyber-configuration-dimension.ts'
export * from './rcph-guarantee-description.ts'
export * from './rcph-guarantee-description-text.ts'
export * from './rcph-guarantee-names.ts'
export * from './rcph-guarantee-text.ts'
export * from './rcph-loi-dimension.ts'
export * from './rcph-option-monde-dimension.ts'
export * from './rcph-optional-guarantee-children.ts'
export * from './rcph-optional-guarantee-description.ts'
export * from './rcph-optional-guarantee-description-text.ts'
export * from './rcph-options-dimension.ts'
export * from './rcph-quote-dimension.ts'
export * from './rcph-tdmi-loi-dimension.ts'
export * from './rcph-trm-loi-dimension.ts'

export const rcphDeductibleMaterielDimension = new AmountDimension({
  name: 'rcphDeductibleMateriel',
  displayKeys: { name: 'dimension_name_rcph_deductible_materiel' },
  considerForDifferenceComputationInUi: { client: false, partner: false, platform: true },
  includeInTrackingMessages: false,
  inputLocking: undefined,
} as const)
export const rcphDeductibleImmaterielDimension = new AmountDimension({
  name: 'rcphDeductibleImmateriel',
  displayKeys: { name: 'dimension_name_rcph_deductible_immateriel' },
  considerForDifferenceComputationInUi: { client: false, partner: false, platform: true },
  includeInTrackingMessages: false,
  inputLocking: undefined,
} as const)
export const rcphDeductibleImmaterielProjetDimension = new AmountDimension({
  name: 'rcphDeductibleImmaterielProjet',
  displayKeys: { name: 'dimension_name_rcph_deductible_immateriel_projet' },
  considerForDifferenceComputationInUi: { client: false, partner: false, platform: true },
  includeInTrackingMessages: false,
  inputLocking: undefined,
} as const)
export const rcphDeductibleCorporelDimension = new AmountDimension({
  name: 'rcphDeductibleCorporel',
  displayKeys: { name: 'dimension_name_rcph_deductible_corporel' },
  considerForDifferenceComputationInUi: { client: false, partner: false, platform: true },
  includeInTrackingMessages: false,
  inputLocking: undefined,
} as const)
export const rcphDeductibleUsaCanadaDimension = new AmountDimension({
  name: 'rcphDeductibleUsaCanada',
  displayKeys: { name: 'dimension_name_rcph_deductible_usa_canada' },
  considerForDifferenceComputationInUi: { client: false, partner: false, platform: true },
  includeInTrackingMessages: false,
  inputLocking: undefined,
} as const)

export const rcphActiviteMaterielTelecomDimension = new BooleanDimension({
  name: 'rcphActiviteMaterielTelecom',
  displayKeys: { name: 'dimension_name_rcph_activite_materiel_telecom' },
  considerForDifferenceComputationInUi: { client: false, partner: false, platform: true },
  includeInTrackingMessages: false,
  inputLocking: undefined,
} as const)
export const rcphActiviteMiseEnRelationDimension = new BooleanDimension({
  name: 'rcphActiviteMiseEnRelation',
  displayKeys: { name: 'dimension_name_rcph_activite_mise_en_relation' },
  considerForDifferenceComputationInUi: { client: false, partner: false, platform: true },
  includeInTrackingMessages: false,
  inputLocking: undefined,
} as const)
export const rcphOptionRceDimension = new BooleanDimension({
  name: 'rcphOptionRce',
  displayKeys: { name: 'dimension_name_rcph_option_rce' },
  considerForDifferenceComputationInUi: { client: true, partner: true, platform: true },
  includeInTrackingMessages: false,
  inputLocking: undefined,
} as const)
export const rcphRceDeductibleDimension = new AmountDimension({
  name: 'rcphRceDeductible',
  displayKeys: { name: 'dimension_name_rcph_rce_deductible' },
  considerForDifferenceComputationInUi: { client: false, partner: false, platform: true },
  includeInTrackingMessages: false,
  inputLocking: undefined,
} as const)

export const rcphRceDeductibleCorporelDimension = new AmountDimension({
  name: 'rcphRceDeductibleCorporel',
  displayKeys: { name: 'dimension_name_rcph_rce_deductible_corporel' },
  considerForDifferenceComputationInUi: { client: false, partner: false, platform: true },
  includeInTrackingMessages: false,
  inputLocking: undefined,
} as const)

export const rcphOptionTdmiHasMaterialRiskDimension = new BooleanDimension({
  name: 'rcphOptionTdmiHasMaterialRisk',
  displayKeys: {
    name: 'dimension_name_rcph_option_tdmi_has_material_risk',
    hint: 'dimension_hint_rcph_option_tdmi_has_material_risk',
  },
  considerForDifferenceComputationInUi: { client: false, partner: false, platform: true },
  includeInTrackingMessages: false,
  inputLocking: undefined,
} as const)

/**
 * The amount corresponding to the LOI value. The LOI value itself is a number enum because we can't have indexed types with amounts, and
 * we need them for the configuration of the pricing.
 */
export const rcphEcomTdmiLoiAmountDimension = new AmountDimension({
  name: 'rcphEcomTdmiLoiAmount',
  displayKeys: { name: 'dimension_name_rcph_ecom_tdmi_loi_amount' },
  considerForDifferenceComputationInUi: { client: false, partner: false, platform: true },
  includeInTrackingMessages: false,
  inputLocking: undefined,
} as const)

export const rcphOptionTrmDimension = new BooleanDimension({
  name: 'rcphOptionTrm',
  displayKeys: { name: 'dimension_name_rcph_option_trm' },
  considerForDifferenceComputationInUi: { client: true, partner: true, platform: true },
  includeInTrackingMessages: false,
  inputLocking: undefined,
} as const)

export const rcphOptionTrmHasMaterialRiskDimension = new BooleanDimension({
  name: 'rcphOptionTrmHasMaterialRisk',
  displayKeys: {
    name: 'dimension_name_rcph_option_trm_has_material_risk',
    hint: 'dimension_hint_rcph_option_trm_has_material_risk',
  },
  considerForDifferenceComputationInUi: { client: false, partner: false, platform: true },
  includeInTrackingMessages: false,
  inputLocking: undefined,
} as const)

export const rcphOptionCyberDommagesPeDimension = new BooleanDimension({
  name: 'rcphOptionCyberDommagesPe',
  displayKeys: { name: 'dimension_name_rcph_option_cyber_dommages_pe' },
  considerForDifferenceComputationInUi: { client: true, partner: true, platform: true },
  includeInTrackingMessages: false,
  inputLocking: undefined,
} as const)
export const rcphOptionCyberDefaillanceFournisseurDimension = new BooleanDimension({
  name: 'rcphOptionCyberDefaillanceFournisseur',
  displayKeys: { name: 'dimension_name_rcph_option_cyber_defaillance_fournisseur' },
  considerForDifferenceComputationInUi: { client: true, partner: true, platform: true },
  includeInTrackingMessages: false,
  inputLocking: undefined,
} as const)
export const rcphOptionCyberDommagesTiersDimension = new BooleanDimension({
  name: 'rcphOptionCyberDommagesTiers',
  displayKeys: { name: 'dimension_name_rcph_option_cyber_dommages_tiers' },
  considerForDifferenceComputationInUi: { client: true, partner: true, platform: true },
  includeInTrackingMessages: false,
  inputLocking: undefined,
} as const)
export const rcphOptionCyberFraudePiratageDimension = new BooleanDimension({
  name: 'rcphOptionCyberFraudePiratage',
  displayKeys: { name: 'dimension_name_rcph_option_cyber_fraude_piratage' },
  considerForDifferenceComputationInUi: { client: true, partner: true, platform: true },
  includeInTrackingMessages: false,
  inputLocking: undefined,
} as const)
export const rcphOptionCyberHasExcludedActivitiesDimension = new BooleanDimension({
  name: 'rcphOptionCyberHasExcludedActivities',
  displayKeys: {
    name: 'dimension_name_rcph_option_cyber_has_excluded_activities',
    hint: 'dimension_hint_rcph_option_cyber_has_excluded_activities',
  },
  considerForDifferenceComputationInUi: { client: false, partner: false, platform: true },
  includeInTrackingMessages: false,
  inputLocking: undefined,
} as const)
export const rcphCyberHighOnlineRevenueDimension = new BooleanDimension({
  name: 'rcphCyberHighOnlineRevenue',
  displayKeys: { name: 'dimension_name_rcph_cyber_high_online_revenue' },
  considerForDifferenceComputationInUi: { client: true, partner: true, platform: true },
  includeInTrackingMessages: false,
  inputLocking: undefined,
} as const)
export const rcphCyberManyCreditCardPaymentsDimension = new BooleanDimension({
  name: 'rcphCyberManyCreditCardPayments',
  displayKeys: { name: 'dimension_name_rcph_cyber_many_credit_card_payments' },
  considerForDifferenceComputationInUi: { client: true, partner: true, platform: true },
  includeInTrackingMessages: false,
  inputLocking: undefined,
} as const)
export const rcphOptionCyberHasItRiskDimension = new BooleanDimension({
  name: 'rcphOptionCyberHasItRisk',
  displayKeys: {
    name: 'dimension_name_rcph_option_cyber_has_it_risk',
    hint: 'dimension_hint_rcph_option_cyber_has_it_risk',
  },
  considerForDifferenceComputationInUi: { client: false, partner: false, platform: true },
  includeInTrackingMessages: false,
  inputLocking: undefined,
} as const)

export const rcphOptionFreedomAdvantageDimension = new BooleanDimension({
  name: 'rcphOptionFreedomAdvantage',
  displayKeys: { name: 'dimension_name_rcph_option_freedom_advantage' },
  considerForDifferenceComputationInUi: { client: true, partner: true, platform: true },
  includeInTrackingMessages: false,
  inputLocking: undefined,
} as const)

export const rcphYearlyBasePremiumDimension = new AmountDimension({
  name: 'rcphYearlyBasePremium',
  displayKeys: { name: 'dimension_name_rcph_yearly_base_premium' },
  considerForDifferenceComputationInUi: { client: false, partner: false, platform: true },
  includeInTrackingMessages: false,
  inputLocking: undefined,
} as const)
export const rcphYearlyTaxesDimension = new AmountDimension({
  name: 'rcphYearlyTaxes',
  displayKeys: { name: 'dimension_name_rcph_yearly_taxes' },
  considerForDifferenceComputationInUi: { client: false, partner: false, platform: true },
  includeInTrackingMessages: false,
  inputLocking: undefined,
} as const)
export const rcphYearlyTotalPremiumDimension = new AmountDimension({
  name: 'rcphYearlyTotalPremium',
  displayKeys: { name: 'dimension_name_rcph_yearly_total_premium' },
  considerForDifferenceComputationInUi: { client: false, partner: false, platform: true },
  includeInTrackingMessages: true,
  inputLocking: undefined,
} as const)
export const rcphYearlyPjPremiumDimension = new AmountDimension({
  name: 'rcphYearlyPjPremium',
  displayKeys: { name: 'dimension_name_rcph_yearly_pj_premium' },
  considerForDifferenceComputationInUi: { client: false, partner: false, platform: true },
  includeInTrackingMessages: false,
  inputLocking: undefined,
} as const)

export const rcphExclusionsDimension = new ExclusionDimension({
  name: 'rcphExclusions',
  displayKeys: { name: 'dimension_name_rcph_exclusions' },
  considerForDifferenceComputationInUi: { client: false, partner: false, platform: false },
  includeInTrackingMessages: false,
  inputLocking: undefined,
} as const)

export const rcphActivityEventsDimension = new BooleanDimension({
  name: 'rcphActivityEvents',
  displayKeys: { name: 'dimension_name_rcph_activity_events' },
  considerForDifferenceComputationInUi: { client: false, partner: false, platform: true },
  includeInTrackingMessages: false,
  inputLocking: undefined,
} as const)
export const rcphActivityMnaDimension = new BooleanDimension({
  name: 'rcphActivityMna',
  displayKeys: { name: 'dimension_name_rcph_activity_mna' },
  considerForDifferenceComputationInUi: { client: false, partner: false, platform: true },
  includeInTrackingMessages: false,
  inputLocking: undefined,
} as const)
export const rcphActivityTemporaryEmploymentDimension = new BooleanDimension({
  name: 'rcphActivityTemporaryEmployment',
  displayKeys: { name: 'dimension_name_rcph_activity_temporary_employment' },
  considerForDifferenceComputationInUi: { client: false, partner: false, platform: true },
  includeInTrackingMessages: false,
  inputLocking: undefined,
} as const)
export const rcphActivityEcomDimension = new BooleanDimension({
  name: 'rcphActivityEcom',
  displayKeys: { name: 'dimension_name_rcph_activity_ecom' },
  considerForDifferenceComputationInUi: { client: false, partner: false, platform: true },
  includeInTrackingMessages: false,
  inputLocking: undefined,
} as const)
export const rcphDerogExcluProfReglDimension = new BooleanDimension({
  name: 'rcphDerogExcluProfRegl',
  displayKeys: { name: 'dimension_name_rcph_derog_exclu_prof_regl' },
  considerForDifferenceComputationInUi: { client: false, partner: false, platform: true },
  includeInTrackingMessages: false,
  inputLocking: undefined,
} as const)
export const isRcphOrganisationCustomServiceDimension = new BooleanDimension({
  name: 'isRcphOrganisationCustomService',
  displayKeys: { name: 'dimension_name_is_rcph_organisation_custom_service' },
  considerForDifferenceComputationInUi: { client: false, partner: false, platform: true },
  includeInTrackingMessages: false,
  inputLocking: undefined,
} as const)
export const isRcphActivityBorlooDimension = new BooleanDimension({
  name: 'isRcphActivityBorloo',
  displayKeys: { name: 'dimension_name_is_rcph_activity_borloo' },
  considerForDifferenceComputationInUi: { client: false, partner: false, platform: true },
  includeInTrackingMessages: false,
  inputLocking: undefined,
} as const)
export const rcphActivityTravelPlannerDimension = new BooleanDimension({
  name: 'rcphActivityTravelPlanner',
  displayKeys: { name: 'dimension_name_rcph_activity_travel_planner' },
  considerForDifferenceComputationInUi: { client: false, partner: false, platform: true },
  includeInTrackingMessages: false,
  inputLocking: undefined,
} as const)

export const manuallySetRcphManagementFeeRateDimension = new FinancialRateWithUnsetDimension({
  name: 'manuallySetRcphManagementFeeRate',
  displayKeys: { name: 'dimension_name_manually_set_rcph_management_fee_rate' },
  considerForDifferenceComputationInUi: { client: false, partner: false, platform: true },
  includeInTrackingMessages: false,
  inputLocking: undefined,
} as const)

export const defaultRcphManagementFeeRateDimension = new FinancialRateDimension({
  name: 'defaultRcphManagementFeeRate',
  displayKeys: { name: 'dimension_name_default_rcph_management_fee_rate' },
  considerForDifferenceComputationInUi: { client: false, partner: false, platform: true },
  includeInTrackingMessages: false,
  inputLocking: undefined,
} as const)

export const rcphManagementFeeRateDimension = new FinancialRateDimension({
  name: 'rcphManagementFeeRate',
  displayKeys: { name: 'dimension_name_rcph_management_fee_rate' },
  considerForDifferenceComputationInUi: { client: false, partner: false, platform: true },
  includeInTrackingMessages: true,
  inputLocking: undefined,
} as const)

export const rcphPremiumOverchargeDimension = new FinancialRateDimension({
  name: 'rcphPremiumOvercharge',
  displayKeys: { name: 'dimension_name_rcph_premium_overcharge' },
  configuration: {
    min: 0,
    max: Infinity,
    step: 0.01,
  },
  considerForDifferenceComputationInUi: { client: false, partner: false, platform: true },
  includeInTrackingMessages: true,
  inputLocking: undefined,
} as const)
